// config is used through most of the game files and shoulc contain alll games constants
import config from './config';

import DataManager from './utils/DataManager';
import SoundManager from './utils/SoundManager';

// The scenes that make up our game
import Boot from './scene/Boot';
import Preload from './scene/Preload';
import Intro from './scene/Intro';
import Play from './scene/Play';
import Score from './scene/Score';
import Settings from './scene/Settings';
import DeviceManager from './utils/DeviceManager';
import DeviceOrientationChecker from './utils/DeviceOrientationChecker';
import WebFontLoaderPlugin from './utils/webfontloader/rexwebfontloaderplugin';
import LocalisationManager from './utils/LocalisationManager';

let gameStarted = false;

let isLandscape = config.WIDTH > config.HEIGHT;

//Load style
var head = document.getElementsByTagName("head")[0];
var link = document.createElement("link");
link.type = "text/css";
link.rel = "stylesheet";
link.href = "media/css/main.css";
head.appendChild(link);

let rootElement = document.getElementById('local-game-holder');

let deviceManager =            new DeviceManager();
let deviceOrientationChecker = new DeviceOrientationChecker(deviceManager, isLandscape, rootElement);    

deviceOrientationChecker.onValidOrientation = OnValidOrientation.bind(this);
deviceOrientationChecker.Resize();

function OnValidOrientation() {

  startGame();
  //Prevent additional instance creation upon valid orientation / Brim hiding
  deviceOrientationChecker.onValidOrientation = null;
  
}

function startGame () {
  if (gameStarted) {
    return;
  }

  gameStarted = true;
  // console.log('startGame');

  //Create stage
  var stage = document.createElement('div');
  stage.id = 'stage-container';
  
  rootElement.appendChild(stage);

  var scaleMode = isLandscape ? Phaser.Structs.Size.HEIGHT_CONTROLS_WIDTH : Phaser.Structs.Size.WIDTH_CONTROLS_HEIGHT;

  //For playing on desktop without iframe
  if(deviceManager.desktop && window.innerWidth > window.innerHeight){
      scaleMode = Phaser.Structs.Size.HEIGHT_CONTROLS_WIDTH;
      config.HEIGHT = 1024;
      config.CENTER_X = config.WIDTH / 2;
      config.CENTER_Y = config.HEIGHT / 2;
      config.ASPECT_RATIO = config.WIDTH / config.HEIGHT;
  }

  var audioContext = new ((window).AudioContext || (window).webkitAudioContext)();

  let game = new Phaser.Game({
    type: Phaser.CANVAS,
    parent: stage.id,
    fullscreenTarget: rootElement,
    scale:{
        mode: scaleMode,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: config.WIDTH,
        height: config.HEIGHT,
        autoRound: true
    },
    render:{
      antialias: true,
      pixelArt: false,
      roundPixels: false,
      transparent: false
  },
    audio: {
      context: audioContext
    },
    plugins: {
        global: [
            {
                key: 'WebFontLoader',
                plugin: WebFontLoaderPlugin,
                start: true
            }
        ]
    }
  });

  game.dataManager = new DataManager();
  game.localisationManager = new LocalisationManager();

  game.scene.add('Boot', Boot);
  game.scene.add('Preload', Preload);
  game.scene.add('Intro', Intro);
  game.scene.add('Play', Play);
  game.scene.add('Score', Score);
  game.scene.add('Settings', Settings);
  game.scene.add('SoundManager', SoundManager);
  game.scene.start('Boot');

  game.sound.pauseOnBlur = false;

  //Fix for IOS13 audio bug
  window.addEventListener("blur", function(event)
  {
    audioContext = game.sound.context;
    if (audioContext.state==='running') {
      audioContext.suspend();
    }
  }, false);

  window.addEventListener("focus", function(event)
  {
    setTimeout(function(){
      audioContext = game.sound.context;
      if (audioContext.state==='suspended') {
        audioContext.resume();
      }
    }, 500);
  }, false);

  deviceOrientationChecker.game = game;

  game.deviceManager = deviceManager;

  window.focus();

}
